/**
 * Path Utilities
 *
 * Centralized path handling functions for consistent path operations across the app.
 * Paths follow the format: "space/folder/subfolder/list"
 */

/**
 * Check if a path matches a filter path
 * Filter matches if:
 * - Paths are equal
 * - Task path starts with filter path + '/'
 */
export function matchesFilterPath(taskPath: string | null | undefined, filterPath: string | null | undefined): boolean {
  if (!filterPath) return true; // No filter = match all
  if (!taskPath) return false;

  // ID-based paths: exact prefix matching (case-sensitive)
  return taskPath === filterPath || taskPath.startsWith(filterPath + '/');
}

/**
 * Build a task path from task properties
 */
export function buildTaskPath(
  spaceName: string | undefined,
  folderPath: string[] | undefined,
  listName: string | undefined
): string {
  const parts = [spaceName, ...(folderPath ?? []), listName].filter(Boolean) as string[];
  return parts.join('/');
}
